function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.829 9l4.292 4.293-1.414 1.414L1 8l6.707-6.707 1.414 1.414L4.828 7H15v2H4.83z",
  fill: "#F4F6F8"
});

var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuODI4NSA5LjAwMDE1TDkuMTIxMzIgMTMuMjkzTDcuNzA3MTEgMTQuNzA3MkwxIDguMDAwMDhMNy43MDcxMSAxLjI5Mjk3TDkuMTIxMzIgMi43MDcxOEw0LjgyODM1IDcuMDAwMTVMMTUuMDAwMiA3LjAwMDE1VjkuMDAwMTVMNC44Mjg1IDkuMDAwMTVaIiBmaWxsPSIjRjRGNkY4Ii8+Cjwvc3ZnPgo=";
export { SvgArrowBack as ReactComponent };